import { Communicator, ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { TextGenerator, TextGeneratorComplete, TextGeneratorInboundValue } from './TextGenerator';

type InboundLlmTokenPacket = {
    subjectId: string,
    sequence: number,
    batch: string[],
};

export class TextGeneratorMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(Communicator) private comms!: Communicator;

    public start() {
        this.burden(
            this.comms.recv('llm_token', (from, data: InboundLlmTokenPacket) => {
                this.onReceiveTokens(data);
            })
        );
    }

    private onReceiveTokens({ subjectId, sequence, batch }: InboundLlmTokenPacket) {
        // Find the subjectId
        const generator = this.objects.getMaybe(subjectId, TextGenerator);
        if (!generator) {
            console.warn(`No generator found for subjectId: ${subjectId}`);
            return;
        }

        // If first in sequence, start from blank, otherwise start from the last value
        const current = sequence === 0 ? '' : TextGeneratorInboundValue.get(generator) || '';
        const next = current + batch.join('');

        TextGeneratorInboundValue.set(generator, next);
        TextGeneratorComplete.setMaybe(generator, false);

        this.scheduler.timeout(subjectId, 2000, () => {
            TextGeneratorComplete.setMaybe(generator, true);
        });
    }
}
